<div id="newrequest-container">
  <div class="row col-12" *ngIf="canCreateIncidents || canCreateServiceRequests || canCreateChangeRequests">
    <span class="zsd-cust-common-pageheading-font active"
      id="createrequestheading">{{ 'NewRequest.createnewrequest' | translate }} </span>
  </div>

  <div class="row col-12">
    <div class="card d-none d-lg-inline-block col-3 newrequest_card" *ngIf="canCreateIncidents" data-toggle="modal"
      data-target="#zsd_modal_new_request" (click)="showCreateRequestPage('incident')">
      <div class="card-body">
        <h5 class="card-title request_title"> <img src="img/createincident.png" />{{'NewRequest.incident' | translate}}
        </h5>
        <p *ngIf="incidentMessage.length <= 135; else elseBlock" class="card-text request-detail"
          [innerHTML]="_DomSanitizer.bypassSecurityTrustHtml(incidentMessage)"></p>
        <ng-template #elseBlock>
          <p data-toggle="tooltip" data-placement="left"
            [innerHTML]="_DomSanitizer.bypassSecurityTrustHtml(incidentMessage.slice(0,135)+'...')"
            title="{{incidentMessage}}"> </p>
        </ng-template>
      </div>
    </div>

    <div class="card d-none d-lg-inline-block col-3 newrequest_card" *ngIf="canCreateServiceRequests"
      data-toggle="modal" data-target="#zsd_modal_new_request" (click)="showCreateRequestPage('service')">
      <div class="card-body">
        <h5 class="card-title request_title"> <img src="img/createservicerequest.png" />
          {{'NewRequest.servicerequest' | translate}}</h5>
        <p *ngIf="serviceRequestMessage.length <= 135; else elseBlock" class="card-text request-detail"
          [innerHTML]="_DomSanitizer.bypassSecurityTrustHtml(serviceRequestMessage)"></p>
        <ng-template #elseBlock>
          <p data-toggle="tooltip" data-placement="left"
            [innerHTML]="_DomSanitizer.bypassSecurityTrustHtml(serviceRequestMessage.slice(0,135)+'...')"
            title="{{serviceRequestMessage}}"> </p>
        </ng-template>
      </div>
    </div>

    <div class="card d-none d-lg-inline-block col-3 newrequest_card" *ngIf="canCreateChangeRequests" data-toggle="modal"
      data-target="#zsd_modal_new_request" (click)="showCreateRequestPage('change')">
      <div class="card-body">
        <h5 class="card-title request_title"><img src="img/createchangerequest.png" />
          {{'NewRequest.changerequest' | translate}}</h5>
        <p *ngIf="changeRequestMessage.length <= 135; else elseBlock" class="card-text request-detail"
          [innerHTML]="_DomSanitizer.bypassSecurityTrustHtml(changeRequestMessage)">
        </p>

        <ng-template #elseBlock>
          <p data-toggle="tooltip" data-placement="left"
            [innerHTML]="_DomSanitizer.bypassSecurityTrustHtml(changeRequestMessage.slice(0,135)+'...')"
            title="{{changeRequestMessage}}"> </p>
        </ng-template>

      </div>
    </div>
  </div>


  <!-- For Mobile Devices & Tablet Portrait View -->
  <div class="text-center pt-4">
    <div class="d-lg-none newrequest_card" *ngIf="canCreateIncidents">
      <div data-toggle="modal" data-target="#zsd_modal_new_request" (click)="showCreateRequestPage('incident')">
        <h5 class="card-title"> <img src="img/createincident.png" /></h5>
      </div>
    </div>

    <div class="d-lg-none newrequest_card" *ngIf="canCreateServiceRequests">
      <div data-toggle="modal" data-target="#zsd_modal_new_request" (click)="showCreateRequestPage('service')">
        <h5 class="card-title"> <img src="img/createservicerequest.png" /></h5>
      </div>
    </div>

    <div class="d-lg-none  newrequest_card" *ngIf="canCreateChangeRequests">
      <div data-toggle="modal" data-target="#zsd_modal_new_request" (click)="showCreateRequestPage('change')">
        <h5 class="card-title"><img src="img/createchangerequest.png" /></h5>

      </div>
    </div>
  </div>

  <!-- To Display the Quick Call List -->
  <div class="row col-12" *ngIf="showQuickCall">
    <div id="quickcalllist">
      <zsd-quickcalllist></zsd-quickcalllist>
    </div>
  </div>
</div>

<div class="modal" id="zsd_modal_new_request" data-backdrop="static" data-keyboard="false">
  <div class="modal-content">
    <div class="modal-header">
      <div> <img src={{imagePath}}/> <span id="popupHeaderString"> {{ popupHeaderString | translate }} </span></div>
      <button type="button" class="close" data-dismiss="modal" (click)=resetCreateRequest()><em class="fas fa-times"></em></button>
    </div>
    <div class="modal-body" id="override_modal_body" *ngIf=customCategory>
      <zsd-reportincident [customCategory]=customCategory (clearForm)=resetCreateRequest()></zsd-reportincident>
    </div>
  </div>
</div>


<!--[fromNewRequestPage]=fromNewRequest-->